import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, map} from 'rxjs';
import {buildPath} from '@utils/util-builder';
import {ApiResponse} from '@models/api.response';
import {PaymentBlockFeatureResponse} from '@models/payment-block.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentBlockFeatureService {
    private readonly _basePath: string = 'data-core/Hotel';

    constructor(private readonly _http: HttpClient) {}

    toggleFeature(hotelId: number, paymentBlockFeatureEnabled: boolean): Observable<PaymentBlockFeatureResponse> {
        return this._http.patch<ApiResponse<PaymentBlockFeatureResponse>>(
            buildPath([this._basePath, 'payment-block-feature', hotelId.toString()]),
            {paymentBlockFeatureEnabled}
        ).pipe(map((response: ApiResponse<PaymentBlockFeatureResponse>): PaymentBlockFeatureResponse => response.data));
    }
}
